"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autocomplete = autocomplete;
exports["default"] = void 0;
exports.getAccounts = getAccounts;
exports.getClientsData = getClientsData;
exports.getContracts = getContracts;
exports.getContractsCount = getContractsCount;
exports.getFeedbacks = getFeedbacks;
exports.getInvoicingEntities = getInvoicingEntities;
exports.getInvoicingRegions = getInvoicingRegions;
exports.getOffices = getOffices;
exports.getParentAccount = getParentAccount;
exports.getProjectCount = getProjectCount;
exports.getProjects = getProjects;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getParentAccount(parentAccountId) {
  return _api["default"].get("/api/parent-account/".concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjectCount(parentAccountId) {
  return _api["default"].get("/api/parent-account/".concat(parentAccountId, "/projects-count")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getFeedbacks(parentAccountId) {
  return _api["default"].get("/api/parent-account/feedbacks/".concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInvoicingEntities(parentAccountId) {
  return _api["default"].get("/api/invoicing-entity?parentAccountId=".concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function autocomplete(keyword) {
  return _api["default"].get("/api/parent-account/autocomplete?q=".concat(keyword)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAccounts(parentAccountId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    expanded: true
  };
  var params = new window.URLSearchParams();
  Object.keys(options).forEach(function (objectProp) {
    params.append(objectProp, options[objectProp]);
  });
  var url = "/api/account/parent-account/".concat(parentAccountId);
  return _api["default"].get(url, {
    params: params
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getOffices(parentAccountId) {
  return _api["default"].get("/api/office/parent-account/".concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientsData(hash) {
  return _api["default"].get("/api/project/".concat(hash, "/client-data/extern")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjects(payload) {
  return _api["default"].post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/project', payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContractsCount(parentAccountId) {
  return _api["default"].get("/api/parent-account/".concat(parentAccountId, "?bare=true")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContracts(parentAccountId) {
  return _api["default"].get("/api/parent-account/".concat(parentAccountId, "/contracts")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInvoicingRegions() {
  return _api["default"].get('/api/invoicing-region').then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getParentAccount: getParentAccount,
  getProjectCount: getProjectCount,
  getFeedbacks: getFeedbacks,
  getInvoicingEntities: getInvoicingEntities,
  autocomplete: autocomplete,
  getAccounts: getAccounts,
  getOffices: getOffices,
  getProjects: getProjects,
  getContractsCount: getContractsCount,
  getContracts: getContracts,
  getInvoicingRegions: getInvoicingRegions,
  getClientsData: getClientsData
};
var _default = api;
exports["default"] = _default;